import React, { useEffect, useState } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import PieChartFillingGoal from './charts/PieChartFillingGoal';

const WallViewerDashboard = () => {
  const [summary, setSummary] = useState({
    received: 0,
    remaining: 0,
    filled: 0,
    dispatched: 0,
    averiados: 0,
    contributions: [],
  });
  const [monthlyDispatches, setMonthlyDispatches] = useState(0);
  const [avgFillingTime, setAvgFillingTime] = useState(0);

  const fetchSummary = async () => {
    try {
      const res = await fetch('http://3.15.41.152:5000/api/cylinders/summary');
      const data = await res.json();
      setSummary(data);
    } catch (err) {
      console.error('❌ Error fetching summary:', err);
    }
  };

  const fetchMonthlyDispatches = async () => {
    try {
      const res = await fetch('/api/dispatches/monthly');
      const data = await res.json();
      setMonthlyDispatches(data.total || 0);
    } catch (err) {
      console.error('❌ Error fetching monthly dispatches:', err);
    }
  };

  const fetchAvgFillingTime = async () => {
    try {
      const res = await fetch('/api/fillings/average-time');
      const data = await res.json();
      setAvgFillingTime(data.average || 0);
    } catch (err) {
      console.error('❌ Error fetching avg filling time:', err);
    }
  };

  useEffect(() => {
    fetchSummary();
    fetchMonthlyDispatches();
    fetchAvgFillingTime();

    const interval = setInterval(() => {
      fetchSummary();
      fetchMonthlyDispatches();
      fetchAvgFillingTime();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ background: 'var(--mm-bg)', minHeight: '100vh', padding: '20px' }}>
      <Row className="mb-3">
        <Col md={6}>
          <Card style={{ backgroundColor: '#12B8B2', color: '#06222B', padding: '20px', height: '180px' }}>
            <Card.Body className="d-flex flex-column justify-content-center align-items-center h-100">
              <Card.Title style={{ fontSize: '1.5rem' }}>Despachado este mes</Card.Title>
              <Card.Text style={{ fontSize: '3rem', fontWeight: 'bold' }}>{monthlyDispatches}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card style={{ padding: '10px', height: '180px' }}>
            <PieChartFillingGoal />
          </Card>
        </Col>
      </Row>

      <Row className="g-4">
        <Col md={6}>
          <Card style={{ padding: '30px', textAlign: 'center', height: '180px' }}>
            <Card.Body className="d-flex flex-column justify-content-center align-items-center h-100">
              <Card.Title style={{ fontSize: '1.2rem' }}>Total en Planta</Card.Title>
              <Card.Text style={{ fontSize: '3rem', fontWeight: 'bold' }}>{summary.received}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card style={{ padding: '30px', textAlign: 'center', height: '180px' }}>
            <Card.Body className="d-flex flex-column justify-content-center align-items-center h-100">
              <Card.Title style={{ fontSize: '1.2rem' }}>Total por Llenar</Card.Title>
              <Card.Text style={{ fontSize: '3rem', fontWeight: 'bold' }}>{summary.remaining}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card style={{ padding: '30px', textAlign: 'center', height: '180px' }}>
            <Card.Body className="d-flex flex-column justify-content-center align-items-center h-100">
              <Card.Title style={{ fontSize: '1.2rem' }}>Promedio por Llenado (24h)</Card.Title>
              <Card.Text style={{ fontSize: '3rem', fontWeight: 'bold' }}>{avgFillingTime.toFixed(1)} min</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card style={{ padding: '30px', textAlign: 'center', height: '180px' }}>
            <Card.Body className="d-flex flex-column justify-content-center align-items-center h-100">
              <Card.Title style={{ fontSize: '1.2rem' }}>Total Despachado</Card.Title>
              <Card.Text style={{ fontSize: '3rem', fontWeight: 'bold' }}>{summary.dispatched}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default WallViewerDashboard;
